import * as React from "react";
const SVGComponent = ({ color = "#636F7C", ...props }) => (
 <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 640 640"
    width="18"
    height="18"
    {...props}
 >
    <path 
        d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 237.3C544 220.3 537.3 204 525.3 192L448 114.7C436 102.7 419.7 96 402.7 96L160 96zM192 192C192 174.3 206.3 160 224 160L384 160C401.7 160 416 174.3 416 192L416 256C416 273.7 401.7 288 384 288L224 288C206.3 288 192 273.7 192 256L192 192zM320 352C355.3 352 384 380.7 384 416C384 451.3 355.3 480 320 480C284.7 480 256 451.3 256 416C256 380.7 284.7 352 320 352z"
        fill={color}
    />
 </svg>
);
export default SVGComponent;